import { createFileRoute, redirect } from '@tanstack/react-router'

export const redirectLegacySnapdragonSettings = ({ params }: { params: { orgId: number } }) => {
  throw redirect({
    to: '/$orgId/settings/integrations/snapdragon',
    params: { orgId: params.orgId },
    replace: true,
  })
}

export const Route = createFileRoute('/_authenticated/$orgId/settings/snapdragon/')({
  loader: redirectLegacySnapdragonSettings,
})
